export const roundAndReturnString = (inputString, numberDecimals) => {
    if (!numberDecimals){
        numberDecimals = 2;
    }
    let outputAmount = (+inputString).toFixed(numberDecimals);
    outputAmount = outputAmount.toString();
    return outputAmount;
}
export default roundAndReturnString;